"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var StickyContainer = _styledComponents.default.div.withConfig({
  displayName: "StickyContainer",
  componentId: "sc-1nx9k7r-0"
})(["position:sticky;top:0;z-index:100;background:", ";display:flex;justify-content:space-around;box-shadow:0 2px 4px rgba(0,0,0,0.1);"], _colors.OLAF);

var _default = StickyContainer;
exports.default = _default;
module.exports = exports.default;